/* eslint-disable no-case-declarations */
import React, { useEffect, useState } from "react";
import get from "lodash/get";
import PropTypes from "prop-types";
import { SocialShare } from "@quintype/components";
import { Text } from "../../Atoms/StoryElements/Text";
import { Quote } from "../../Atoms/StoryElements/Quote";
import { Blurb } from "../../Atoms/StoryElements/Blurb";
import { Image } from "../../Atoms/StoryElements/Image";
import { Video } from "../../Atoms/StoryElements/Video";
import { Summary } from "../../Atoms/StoryElements/Summary";
import { BigFact } from "../../Atoms/StoryElements/BigFact";
import { AlsoRead } from "../../Atoms/StoryElements/AlsoRead";
import { Reference } from "../../Atoms/StoryElements/Reference";
import { BlockQuote } from "../../Atoms/StoryElements/BlockQuote";
import { Attachment } from "../../Atoms/StoryElements/Attachment";
import { createBrowserHistory, createMemoryHistory } from "history";
import { CaptionAttribution } from "../../Atoms/CaptionAttribution";
import { ImageGallery } from "../../Atoms/StoryElements/imageGallery";
import { StoryElement } from "../../Atoms/StoryElements/StoryElement";
import { SocialShareTemplate } from "../../Molecules/SocialShareTemplate";
import { ImageSlideshow } from "../../Atoms/StoryElements/ImageSlideshow";
import { QuestionAnswer } from "../../Atoms/StoryElements/QuestionAnswer";
import { facebookMobileVideoResizeFix, getTextColor } from "../../../utils/utils";
import JWplayerResumeVideo from "../../../../components/atoms/audio-video-players/jw-player/jwplayer-resume";
import "./story-element-card.m.css";

const getElementType = (element) => element.subtype || element.type || "";
const getElement = (story, config = {}, AdComponent, WidgetComp, index, cardId) => {
  //const myelements=story.cards.map(element => element["story-elements"])
  const elementnew =
  story.cards
    .flatMap((card) => card["story-elements"])
    const element = elementnew[1]
  const {
    text = {},
    summary = {},
    blurb = {},
    blockquote = {},
    quote = {},
    "also-read": alsoRead = {},
    "q-and-a": qaElement = {},
    question: questionElement = {},
    answer: answerElement = {},
    references = {},
  } = config;

  const playerRef = React.useRef(null);
  const videoJsOptions = (element) => {
    let type =
      element.type === "youtube-video"
        ? "video/youtube"
        : element.type === "jsembed"
        ? `video/${element.url.split(".").pop()}`
        : null;
    return {
      autoplay: false,
      controls: true,
      responsive: true,
      fluid: true,
      sources: [
        {
          src: element.url,
          type: type,
        },
      ],
    };
  };
  const handlePlayerReady = (player) => {
    playerRef.current = player;
    player.on("waiting", () => {
      console.log("player is waiting");
    });

    player.on("dispose", () => {
      console.log("player will dispose");
    });
  };
  const [elementModified, setEmentModified] = useState({});
  const [audios, setAudios] = useState(false);
  const [jWplayer, setJWplayer] = useState(false);
  const [shouldReload, setShouldReload] = useState(false);
  const [videoObject, setVideoObject] = useState({});
  let history;

  if (typeof window !== "undefined") {
    history = createBrowserHistory(); // Safe to use in browser
  } else {
    history = createMemoryHistory(); // Use for SSR
  }
  const handleDataFromChild = (data) => {
    if (data) {
      setShouldReload(true);
    }
  };
  useEffect(() => {
    if (shouldReload) {
      history.back();
    }
  }, [shouldReload]);

  function jwplayerFileUrl(playerUrl) {
    const match = playerUrl.match(/https:\/\/cdn\.jwplayer\.com\/players\/([A-Za-z0-9]+)-([A-Za-z0-9]+)\.html/);
    if (match) {
      const videoId = match[1]; // Extract video ID (e.g., HIM68SUM)
      const libraryId = match[2]; // Extract player key (e.g., gDBTQBre)
      return { videoId, libraryId };
    } else {
      return null;
    }
  }

  useEffect(() => {
    // Function to decode the 'embed-js' and extract the URL
    const decodeAndAddUrl = () => {
      if (typeof window === "undefined") {
        return null;
      } else if (element["embed-js"]) {
        const decodedString = window.atob(element["embed-js"]);
        const urlMatch = decodedString.match(/src="([^"]+)"/);
        const url = urlMatch ? urlMatch[1] : decodedString;
        if (url.includes("https://stream.dei.fi:8443")) {
          setAudios(true);
        } else if (url.includes("https://cdn.jwplayer.com")) {
          setJWplayer(true);
          const { videoId, libraryId } = jwplayerFileUrl(url);
          const singleVideoFile = `https://cdn.jwplayer.com/v2/media/${videoId}`;
          setVideoObject({ singleVideoFile, libraryId });
        }
        const updatedElement = {
          ...element,
          url: url,
        };
        setEmentModified(updatedElement);
      }
    };
    decodeAndAddUrl();
  }, [element]);
  let elementType = getElementType(element);
  if (elementType === "image-gallery") {
    elementType = element.metadata.type;
  }
  const storyElementId = get(element, ["id"]);
  switch (elementType) {
    case "ad":
      return <AdComponent {...element} id={`ad-${index}_${cardId}`} />;

    case "widget":
      return <WidgetComp widgetCode={element.config.customCode} id={`widget-${index}_${cardId}`} />;

    case "text":
    case "cta":
      const { css: { textColor: textElementColor = "#000", hyperlinkColor = "#2f81cd" } = {} } = text;
      return null//<Text element={element} css={{ textColor: textElementColor, hyperlinkColor: hyperlinkColor }} />;

    case "summary":
      const {
        template: summaryTemplate = "",
        css: { headerBgColor = "" } = {},
        opts: { headline = "", hideHeadline = false } = {},
      } = summary;
      return (
        <Summary
          element={element}
          template={summaryTemplate}
          opts={{
            headline: headline || "Summary",
            hideHeadline: hideHeadline,
          }}
          css={{ headerBgColor: headerBgColor || "" }}
        />
      );

    case "blurb":
      const { template: blurbTemplate = "default", css: { borderColor = "#2f81cd" } = {} } = blurb;
      return <Blurb element={element} template={blurbTemplate} css={{ borderColor: borderColor }} />;

    case "blockquote":
      const {
        template: blockQuoteTemplate = "default",
        css: { iconType = "edgeIcon", blockQuoteColor = "#2f81cd", backgroundShade = "" } = {},
      } = blockquote;
      return (
        <BlockQuote
          element={element}
          template={blockQuoteTemplate}
          css={{
            iconType: iconType,
            blockQuoteColor: blockQuoteColor,
            backgroundShade: backgroundShade,
          }}
        />
      );

    case "quote":
      const { template: quoteTemplate = "borderNone", css: { borderColor: quoteBorderColor = "#2f81cd" } = {} } = quote;
      return <Quote element={element} template={quoteTemplate} css={{ borderColor: quoteBorderColor }} />;

    case "bigfact":
      return <BigFact element={element} />;

    case "also-read":
      const {
        template: alsoReadTemplate = "default",
        css: { textColor = "#000" } = {},
        opts: { title = "" } = {},
      } = alsoRead;
      return (
        <AlsoRead
          story={story}
          element={element}
          template={alsoReadTemplate}
          css={{ textColor: textColor }}
          opts={{ title }}
        />
      );

    case "image":
      return <Image element={element} />;

    case "q-and-a":
      const {
        template: qaTemplate = "default",
        css: { iconColor = "" } = {},
        opts: { defaultIconType = "edge" } = {},
      } = qaElement;
      return (
        <QuestionAnswer
          element={element}
          opts={{
            type: "q-and-a",
            defaultIconType: defaultIconType,
          }}
          template={qaTemplate}
          css={{
            iconColor: iconColor,
          }}
        />
      );

    case "question":
      const {
        template: questionTemplate = "default",
        css: { questionIconColor = "" } = {},
        opts: { defaultQuestionIconType = "edge" } = {},
      } = questionElement;
      return (
        <QuestionAnswer
          element={element}
          opts={{
            type: "question",
            defaultIconType: defaultQuestionIconType,
          }}
          template={questionTemplate}
          css={{
            iconColor: questionIconColor,
          }}
        />
      );

    case "answer":
      const {
        template: answerTemplate = "default",
        css: { answerIconColor = "" } = {},
        opts: { defaultAnswerIconType = "edge" } = {},
      } = answerElement;
      return (
        <QuestionAnswer
          element={element}
          opts={{
            type: "answer",
            defaultIconType: defaultAnswerIconType,
          }}
          template={answerTemplate}
          css={{
            iconColor: answerIconColor,
          }}
        />
      );

    case "gallery":
      return (
        <div className="content-style" id={`image-gallery-${storyElementId}`}>
          <ImageGallery element={element} />
        </div>
      );

    case "slideshow":
      return (
        <div className="content-style" id={`image-slideshow-${storyElementId}`}>
          <ImageSlideshow element={element} />
        </div>
      );

    case "youtube-video":
    case "dailymotion-video":
      return (
        <div className="content-style" id={`video-${storyElementId}`}>
          <Video element={element} story={story} loadIframeOnClick={true} />
        </div>
      );
    case "attachment":
      return <Attachment element={element} />;
    case "tweet":
    case "jsembed":
      return (
        <div className="content-style" id={`jsembed-${storyElementId}`}>
          {!jWplayer && <StoryElement element={element} story={story} />}
          {jWplayer && (
            <JWplayerResumeVideo
              videoObject={videoObject}
              sendDataToParent={handleDataFromChild}
              uniqueId={`jsembed-${storyElementId}`}
            />
          )}
        </div>
      );
    case "references":
      const { opts: { showHeadline = true, headlineText = "" } = {} } = references;
      return (
        <Reference
          element={element}
          opts={{
            showHeadline: showHeadline,
            headlineText: headlineText,
          }}
        />
      );
    default:
      return (
        <div className="content-style" id={`element-${storyElementId}`}>
          <StoryElement element={element} story={story} />
        </div>
      );
  }
};

const MainImageWrapper = ({ imageElement, story, children, config, card }) => {
  return (
    <>
      <div style={{ backgroundColor: config.theme }}>
        <Image element={imageElement} caption={false} />
        <div styleName="image-share">
          <CaptionAttribution element={imageElement} config={config} />
          <SocialShare
            template={SocialShareTemplate}
            title={story.headline}
            theme={config.theme}
            fullUrl={encodeURI(`${get(story, ["url"], "")}?cardId=${get(card, ["id"], -1)}`)}
          />
        </div>
      </div>
    </>
  );
};

MainImageWrapper.propTypes = {
  story: PropTypes.object,
  imageElement: PropTypes.object,
  config: PropTypes.object,
  children: PropTypes.node,
  card: PropTypes.shape({
    id: PropTypes.string,
  }),
};

export const StoryElementCard = ({
  story,
  card,
  heroVideoElementId = -1,
  config,
  isLive,
  theme,
  adComponent,
  widgetComp,
}) => {
  const textColor = getTextColor(theme);
  const isLiveBlog = isLive ? "live-blog" : "";
  let shouldRunFBMobileVideoFix = true;

  return (
    <div className="arr--story-page-card-wrapper">
      {get(card, ["story-elements"], []).map((element, index) => {
        if (element.id === heroVideoElementId) return false;
        if (element.subtype && element.subtype === "facebook-post" && shouldRunFBMobileVideoFix) {
          facebookMobileVideoResizeFix();
          shouldRunFBMobileVideoFix = false;
        }
        const tableStyle = element && element.subtype === "table" ? "table" : "";
        const cardId = get(card, ["id"], "");
        return (
          <div
            key={element.id}
            className="arr--element-container"
            styleName={`element-container ${isLiveBlog} ${tableStyle} ${textColor}`}
          >
            {getElement(story, element, config, adComponent, widgetComp, index, cardId)}
          </div>
        );
      })}
    </div>
  );
};
StoryElementCard.propTypes = {
  story: PropTypes.object,
  card: PropTypes.array,
  heroVideoElementId: PropTypes.number,
  config: PropTypes.object,
  isLive: PropTypes.bool,
  theme: PropTypes.string,
  adComponent: PropTypes.func,
  widgetComp: PropTypes.func,
};

export const PhotoStoryElement = ({ card = {}, config, story, adComponent, widgetComp }) => {
  let shouldRunFBMobileVideoFix = true;
  return (
    <div styleName="story-card">
      {get(card, ["story-elements"], []).map((element, index) => {
        const cardId = get(card, ["id"], "");
        if (element.type === "image") {
          return <MainImageWrapper imageElement={element} story={story} config={config} card={card} />;
        } else {
          if (element.subtype && element.subtype === "facebook-post" && shouldRunFBMobileVideoFix) {
            facebookMobileVideoResizeFix();
            shouldRunFBMobileVideoFix = false;
          }
          return (
            <div styleName="element-container" key={index}>
              {getElement(story, element, config, adComponent, widgetComp, index, cardId)}
            </div>
          );
        }
      })}
    </div>
  );
};

PhotoStoryElement.propTypes = {
  story: PropTypes.object,
  card: PropTypes.object,
  config: PropTypes.object,
  adComponent: PropTypes.func,
  widgetComp: PropTypes.func,
};

export const SlotAfterStory = ({ id = "", element = {}, AdComponent, WidgetComp }) => {
  switch (element.type) {
    case "ad":
      return <AdComponent {...element} id={`ad-after-story-${id}`} />;
    case "widget":
      return <WidgetComp widgetCode={element.config.customCode} id={`widget-after-story-${id}`} />;
    default:
      return null;
  }
};

SlotAfterStory.propTypes = {
  id: PropTypes.string,
  element: PropTypes.object,
  AdComponent: PropTypes.func,
  WidgetComp: PropTypes.func,
};
